//------------------------------------------------------------------------
// This file contains site-wide JS that will be packaged into a single file
//
// We’re using the sprockets-commoner gem to enable Babel transformations
// https://github.com/Shopify/sprockets-commoner
//------------------------------------------------------------------------
/* globals require */ // JSHint global vars
'use strict';

// Expose jQuery globally (optional)
window.$ = window.jQuery = require('jquery');

// Emit “font-loaded” event so expandable components know to recalc their height
document.fonts.ready.then(function() {
  let fontEvent = new CustomEvent('fonts-loaded');
  document.documentElement.dispatchEvent(fontEvent);
});

// Detect input method in order to hide outlines in an accessible manner
// https://github.com/ten1seven/what-input
import 'what-input';

// Picture element polyfill
// Requires background-picture.js and ".js-background-image" CSS in _base.scss
// Can remove once support is broad enough http://caniuse.com/#feat=picture
import 'picturefill';

// Lite YouTube Embed (Web Component that lazy loads the player)
// https://github.com/paulirish/lite-youtube-embed
import 'lite-youtube-embed';

// Modules
import '../modules/analytics';
import '../modules/background-picture';
import '../modules/card-slider';
import '../modules/custom-select';
import '../modules/filters';
import '../modules/filter-menu';
import '../modules/form-validation';
import '../modules/mailto';
import '../modules/nav-mobile-toggle';
import '../modules/nav-submenus';
import '../modules/orphans';
import '../modules/popup-modal';
import '../modules/read-more';
import '../modules/reveal';
import '../modules/scrollable-tables';
import '../modules/select-link';
import '../modules/sticky-header';
import '../modules/anchor-nav-toggle';
import '../modules/accordion-list';
import '../modules/responsive-video';
import '../modules/video-toggle';

import '../components/partner-ad-promo';

// Tabs
import Tabs from '../modules/tabs';
document.querySelectorAll('[data-tabs]').forEach(el => new Tabs(el));

// Vue app
import '../vue/app';